"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var react_1 = __importDefault(require("react"));
var __1 = require("../../..");
var __2 = require("../../../..");
var Select_1 = __importDefault(require("../../../Select"));
var PsrActionInput = function () {
    var _a, _b;
    var trans = __2.useSemantics().trans;
    var errors = formik_1.useFormikContext().errors;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(__1.FormControl, { errors: (_b = (_a = errors.project) === null || _a === void 0 ? void 0 : _a.warm_home) === null || _b === void 0 ? void 0 : _b.psr_action, label: trans('project:slhh::labels.psr-action'), flush: true },
            react_1.default.createElement(Select_1.default, { width: "xs", options: {
                    registered_with_psr: 'Registered client with PSR',
                    registered: 'Client already registered',
                    will_register: 'Client to register following visit',
                    not_eligible: 'None (client not eligible)',
                }, name: "project.warm_home.psr_action" }))));
};
exports.default = PsrActionInput;
//# sourceMappingURL=PsrActionInput.js.map